import { useAvailablePersonas } from '@festina-life/authentication'

import {
  type ConfigurationPersona,
  isConfigurationPersona,
} from '../uiModels/types'

export const useAvailableConfigurationPersonas = (): ConfigurationPersona[] => {
  const personas = useAvailablePersonas<string>()
  return personas.filter(isConfigurationPersona)
}
